// OutgoingPresidentQuoteSection

import Container from "../../../components/ui/Container";

export default function OutgoingPresidentQuoteSection() {
  return (
    <section className="event-noise bg-twilight-indigo-950 px-0 py-20 text-white md:py-28">
      <Container>
        <div className="mx-auto max-w-3xl text-center">
          <div className="mx-auto mb-14 h-16 w-px bg-amber-flame-500/70" />

          <div className="mx-auto mb-16 h-40 w-40 overflow-hidden rounded-full border border-white/15 bg-slate-200 md:h-48 md:w-48">
            <img
              src="/images/dr-edna-johnny.jpeg"
              alt="Dr. Edna G. Johnny"
              className="h-full w-full object-cover"
            />
          </div>

          <div className="mx-auto max-w-2xl space-y-10">
            <p className="font-serif text-xl italic leading-relaxed text-slate-100 md:text-2xl">
              “Yesterday, we demonstrated our commitment to a mature democratic
              process as a testament to how Liberia can progress despite
              differences in ideology.”
            </p>

            <p className="font-serif text-xl italic leading-relaxed text-slate-100 md:text-2xl">
              “...elections produce winners and losers, but in ULFA, we are all
              winners.”
            </p>

            <p className="font-serif text-xl italic leading-relaxed text-slate-100 md:text-2xl">
              Congratulations to everyone, Congratulations to ULFA!!”
            </p>
          </div>

          <div className="mt-16">
            <h2 className="font-display text-3xl font-bold leading-tight text-white md:text-4xl">
              Dr. Edna G. Johnny
            </h2>

            <p className="mt-3 text-xs font-semibold uppercase tracking-[0.5em] text-amber-flame-500">
              Outgoing President, ULFA
            </p>
          </div>

          <div className="mx-auto mt-16 h-16 w-px bg-amber-flame-500/70" />
        </div>
      </Container>
    </section>
  );
}